<template>
  <nav class=" pl-nav pl-color pl-color--gray-darkest"
       id="main-header"
       data-dualheader="false"
       data-header-type="business"
       data-header-business="/businessheader.html"
       role="navigation">
    <div class="pl-visually-hidden"
         aria-live="polite"
         role="status"
         id="sr-notification"></div>
    <a href="/"
       class="pl-nav__logo">
      <!-- <CanonLogo /> -->
      <img style="height:36px;width:168px"
           alt="canonlogo"
           src="../assets/FFP/images/logo3.png" />
      <!-- <img v-bind:src="getImagePath(content.logo)" class="pl-image-inline" alt="Canon" /> -->
      <span class="pl-visually-hidden">canon.svg</span>
    </a>
    <div class="pl-nav__wrap">
      <ul class="pl-nav__menu">
        <li v-for="(header_link, index) in content.links"
            v-if="index===0? false:true"
            v-bind:key="index"
            class="pl-nav__item hidden-lg-down pl-nav__item--SimpleLink dropdown"
            data-mobile-include="true">
          <a v-bind:href="header_link.url"
             target="_self"
             class="pl-nav__link">
            <span class="hidden-lg-down">{{header_link.title}}</span>
            <span class="hidden headeren">{{header_link.title}}</span>
          </a>

        </li>
        <!-- <li class="pl-nav__item pl-nav__item--search-mobile hidden-xl-up"
            data-mobile-include="false"><a href="#"
             class="pl-nav__link">
            <span class="hidden-lg-down">search</span>
          </a></li> -->
      </ul>

      <!-- <ul class="pl-nav__tools hidden-lg-down">
        <li class="pl-nav__item pl-nav__item--search"><a href="javascript:void(0);"
             class="pl-nav__link pl-search-trigger">
            <span class="pl-visually-hidden">search</span></a></li>
      </ul> -->
    </div>
    <!-- TODO:小分辨率导航栏 -->
    <div class="hidden-lg-down_menu">
      <!-- <ul>
        <li v-for="(header_link, index) in content.links"
            v-bind:key="index"
            class="pl-nav__item pl-nav__item--SimpleLink"
            data-mobile-include="true">
          <a v-bind:href="header_link.url"
             target="_self"
             class="pl-nav__link">
            <span>{{header_link.title}}</span>
          </a>
        </li>
      </ul> -->
    </div>
    <a href="/"
       class="pl-nav__logo2">
      <!-- <CanonLogo /> -->
      <img style="height:36px;width:86px"
           alt="canonlogo"
           src="../assets/FFP/images/logo2.png" />
      <!-- <img v-bind:src="getImagePath(content.logo)" class="pl-image-inline" alt="Canon" /> -->
      <span class="pl-visually-hidden">canon.svg</span>
    </a>
    <div :style="show_menu? '':'position:absolute'"
         class="phoneMenuShade">
      <svg t="1575296712159"
           class="icon"
           @click="showMenu"
           v-show="!show_menu"
           viewBox="0 0 1024 1024"
           version="1.1"
           xmlns="http://www.w3.org/2000/svg"
           p-id="1937"
           width="20"
           height="20">
        <path d="M918.507 443.947H104.64c-37.547 0-68.16 30.72-68.16 68.16 0 37.546 30.72 68.16 68.16 68.16h813.867c37.546 0 68.16-30.72 68.16-68.16s-30.72-68.16-68.16-68.16z m-0.32 306.88H104.32c-37.547 0-68.16 30.72-68.16 68.16 0 37.546 30.72 68.16 68.16 68.16h813.867c37.546 0 68.16-30.72 68.16-68.16 0-37.547-30.614-68.16-68.16-68.16z m1.066-610.667H105.387c-37.547 0-68.16 30.72-68.16 68.16 0 37.547 30.72 68.16 68.16 68.16h813.866c37.547 0 68.16-30.72 68.16-68.16 0-37.547-30.72-68.16-68.16-68.16z"
              fill="#ffffff"
              p-id="1938"></path>
      </svg>
      <svg t="1575296615599"
           class="icon"
           @click="showMenu"
           v-show="show_menu"
           viewBox="0 0 1024 1024"
           version="1.1"
           xmlns="http://www.w3.org/2000/svg"
           p-id="2686"
           width="20"
           height="20">
        <path d="M886.528 908.032c-28.096 28.096-73.856 28.096-102.016 0L138.304 261.824c-28.096-28.16-28.16-73.856 0-102.016 28.032-28.16 73.792-28.16 102.08 0l646.144 646.144C914.624 834.24 914.752 879.872 886.528 908.032L886.528 908.032zM885.76 261.504 239.616 907.648c-28.224 28.224-73.92 28.224-102.08 0-28.16-28.096-28.16-73.728 0.064-102.016L783.744 159.552c28.224-28.16 73.984-28.16 102.016-0.064C913.984 187.648 913.856 233.344 885.76 261.504L885.76 261.504z"
              fill="#ffffff"
              p-id="2687"></path>
      </svg>
    </div>
    <div class="phone_menu"
         v-if="show_menu">
      <div>
        <!-- <svg t="1575296615599"
             class="icon"
             @click="showMenu"
             viewBox="0 0 1024 1024"
             version="1.1"
             xmlns="http://www.w3.org/2000/svg"
             p-id="2686"
             width="30"
             height="30">
          <path d="M886.528 908.032c-28.096 28.096-73.856 28.096-102.016 0L138.304 261.824c-28.096-28.16-28.16-73.856 0-102.016 28.032-28.16 73.792-28.16 102.08 0l646.144 646.144C914.624 834.24 914.752 879.872 886.528 908.032L886.528 908.032zM885.76 261.504 239.616 907.648c-28.224 28.224-73.92 28.224-102.08 0-28.16-28.096-28.16-73.728 0.064-102.016L783.744 159.552c28.224-28.16 73.984-28.16 102.016-0.064C913.984 187.648 913.856 233.344 885.76 261.504L885.76 261.504z"
                p-id="2687"></path>
        </svg> -->
        <!-- <img style="height:30px;width:125px"
             alt="canonlogo"
             src="../assets/FFP/images/logo3.png" /> -->
        <ul>
          <li v-for="(header_link, phoneMenuindex) in content.links"
              v-bind:key="phoneMenuindex"
              :style="content.links.length === (phoneMenuindex+1)? 'border-bottom:1px solid #e2e2e2;':''">
            <a v-bind:href="header_link.url"
               target="_self">{{header_link.title}}
            </a>
            <svg t="1578727218990"
                 class="icon"
                 viewBox="0 0 1024 1024"
                 version="1.1"
                 v-show="collapsedIndex===phoneMenuindex? false:true"
                 v-if="header_link.links"
                 @click="collapse(phoneMenuindex)"
                 xmlns="http://www.w3.org/2000/svg"
                 p-id="1688"
                 width="30"
                 height="30">
              <path d="M668.734694 532.897959H355.265306c-11.493878 0-20.897959-9.404082-20.897959-20.897959s9.404082-20.897959 20.897959-20.897959h313.469388c11.493878 0 20.897959 9.404082 20.897959 20.897959s-9.404082 20.897959-20.897959 20.897959z"
                    p-id="1689"
                    fill="#ff3b3b"></path>
              <path d="M512 689.632653c-11.493878 0-20.897959-9.404082-20.897959-20.897959V355.265306c0-11.493878 9.404082-20.897959 20.897959-20.897959s20.897959 9.404082 20.897959 20.897959v313.469388c0 11.493878-9.404082 20.897959-20.897959 20.897959z"
                    p-id="1690"
                    fill="#ff3b3b"></path>
              <path d="M512 929.959184c-230.4 0-417.959184-187.559184-417.959184-417.959184s187.559184-417.959184 417.959184-417.959184 417.959184 187.559184 417.959184 417.959184-187.559184 417.959184-417.959184 417.959184z m0-794.122449c-207.412245 0-376.163265 168.75102-376.163265 376.163265s168.75102 376.163265 376.163265 376.163265 376.163265-168.75102 376.163265-376.163265-168.75102-376.163265-376.163265-376.163265z"
                    p-id="1691"
                    fill="#ff3b3b"></path>
            </svg>
            <svg t="1578729094451"
                 class="icon"
                 v-show="collapsedIndex===phoneMenuindex? true:false"
                 @click="collapse(phoneMenuindex)"
                 viewBox="0 0 1024 1024"
                 version="1.1"
                 xmlns="http://www.w3.org/2000/svg"
                 p-id="1924"
                 width="30"
                 height="30">
              <path d="M668.734694 532.897959H355.265306c-11.493878 0-20.897959-9.404082-20.897959-20.897959s9.404082-20.897959 20.897959-20.897959h313.469388c11.493878 0 20.897959 9.404082 20.897959 20.897959s-9.404082 20.897959-20.897959 20.897959z"
                    p-id="1925"
                    fill="#ff3b3b"></path>
              <path d="M512 929.959184c-230.4 0-417.959184-187.559184-417.959184-417.959184s187.559184-417.959184 417.959184-417.959184 417.959184 187.559184 417.959184 417.959184-187.559184 417.959184-417.959184 417.959184z m0-794.122449c-207.412245 0-376.163265 168.75102-376.163265 376.163265s168.75102 376.163265 376.163265 376.163265 376.163265-168.75102 376.163265-376.163265-168.75102-376.163265-376.163265-376.163265z"
                    p-id="1926"
                    fill="#ff3b3b"></path>
            </svg>
            <p v-show="collapsedIndex===phoneMenuindex? true:false"
               v-for="(secondLink, secondIndex) in header_link.links"
               :key="secondIndex"><a v-bind:href="secondLink.url">{{secondLink.title}}</a></p>
          </li>
        </ul>
      </div>
    </div>

  </nav>
</template>

<script>
import CanonLogo from './CanonLogo.vue'
import contents from '../json/contents.json'

export default {
  name: 'Header',

  components: {
    CanonLogo
  },
  data () {
    return {
      content: '',
      show_menu: false,
      collapsedIndex: ''
    }
  },

  methods: {
    getImagePath (name) {
      var images = require.context('../assets/FFP/images/', true, /\.svg$/)
      return name ? images(name) : ''
    },
    showMenu () {
      this.show_menu = !this.show_menu
      this.collapsedIndex = -1
      this.$emit('hidden', this.show_menu)
    },
    collapse (index) {
      if (this.collapsedIndex !== index) {
        this.collapsedIndex = index
        return
      }
      this.collapsedIndex = -1
    }
  },

  mounted () {
    this.content = contents.header
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='../assets/FFP/css/header.css'></style>



// WEBPACK FOOTER //
// src/components/Header.vue